import React, { useState } from 'react';
import styles from './index.module.less';
import { useRouter } from 'next/router';
import { HomeArticleModel } from '@/types/home';
import { getPathTitle, imgUrl } from '@/shared/utils';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

const CategoryTopContent = ({ list }: { list: HomeArticleModel[] }) => {
  const router = useRouter();

  // 三张图片的加载状态
  const [imageStates, setImageStates] = useState([
    { loading: true, error: false },
    { loading: true, error: false },
    { loading: true, error: false },
  ]);

  const link = (model?: HomeArticleModel) => `/blog/${model.title_id}`;

  const handleClick = (model?: HomeArticleModel) => {
    router.push(link(model));
  };

  const handleImageLoad = (index: number) => {
    setImageStates((prev) => {
      const newStates = [...prev];
      newStates[index] = { loading: false, error: false };
      return newStates;
    });
  };

  const handleImageError = (index: number) => {
    setImageStates((prev) => {
      const newStates = [...prev];
      newStates[index] = { loading: false, error: true };
      return newStates;
    });
  };

  const renderImage = (item: HomeArticleModel, index: number, sizes: string) => {
    const state = imageStates[index];

    return (
      <div className={styles.imageWrapper}>
        {/* 加载中的占位符 */}
        {state.loading && !state.error && (
          <div className={styles.imagePlaceholder}>
            <div className={styles.shimmer}></div>
          </div>
        )}

        {/* 加载失败的占位符 */}
        {state.error && (
          <div className={styles.imageErrorPlaceholder}>
            <svg className={styles.brokenImageIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 5v6.59l-2.29-2.3a1 1 0 0 0-1.42 0L14 12.59 10.71 9.3a1 1 0 0 0-1.42 0L3 15.59V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2zM5 21a2 2 0 0 1-2-2v-.41l6.29-6.3 3.3 3.3a1 1 0 0 0 1.42 0L17.3 12.3l3.7 3.7V19a2 2 0 0 1-2 2H5z"
                fill="currentColor"
              />
              <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
              <line x1="3" y1="3" x2="21" y2="21" stroke="currentColor" strokeWidth="2" />
            </svg>
          </div>
        )}

        {/* 实际图片 */}
        <Image
          className={styles.image}
          src={imgUrl(item.cover_image, 'big')}
          alt={item.title}
          fill
          style={{
            objectFit: 'cover',
            opacity: state.loading || state.error ? 0 : 1,
            transition: 'opacity 0.3s ease-in-out',
          }}
          sizes={sizes}
          priority
          onLoad={() => handleImageLoad(index)}
          onError={() => handleImageError(index)}
        />
      </div>
    );
  };

  return (
    <div className={styles.homeContent}>
      {/* ✅ 使用纯 CSS Grid 替代 Ant Design Row/Col，确保 SSR 和 CSR 布局一致 */}
      <div className={styles.gridContainer}>
        <div
          className={styles.leftContainer}
          onClick={() => {
            list?.length > 0 ? handleClick(list[0]) : undefined;
          }}
        >
          {list?.length > 0 && (
            <>
              {renderImage(list[0], 0, '(max-width: 575px) 100vw, 70vw')}
              <div className={styles.textContainer}>
                <Link href={link(list[0])}>
                  <h2 className={styles.leftTitle}>{list[0].title}</h2>
                </Link>
                <h3 className={styles.leftDesc}>{list[0].description}</h3>
              </div>
            </>
          )}
        </div>
        <div className={styles.rightContainer}>
          <div
            className={styles.rightItem}
            onClick={() => {
              list?.length > 1 ? handleClick(list[1]) : undefined;
            }}
          >
            {list?.length > 1 && (
              <>
                {renderImage(list[1], 1, '(max-width: 575px) 100vw, 30vw')}
                <Link href={link(list[1])}>
                  <h2 className={styles.rightTitle}>{list[1].title}</h2>
                </Link>
                <h3 style={{ display: 'none' }}>{list[1].description}</h3>
              </>
            )}
          </div>
          <div
            className={classNames(styles.rightItem, styles.secondItem)}
            onClick={() => {
              list?.length > 2 ? handleClick(list[2]) : undefined;
            }}
          >
            {list?.length > 2 && (
              <>
                {renderImage(list[2], 2, '(max-width: 575px) 100vw, 30vw')}
                <Link href={link(list[2])}>
                  <h2 className={styles.rightTitle}>{list[2].title}</h2>
                </Link>
                <h3 style={{ display: 'none' }}>{list[2].description}</h3>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryTopContent;
